<p-toast position="center" key="r" [baseZIndex]="1000">
  <ng-template let-content pTemplate="content">
    <div style="text-align: left">
      <h3>{{content.summary}}</h3>
      <div innerHtml="{{content.detail}}">
        <mat-divider>
        </mat-divider>
      </div>
      <button style="float: right" type="button" pButton label="Ok" (click)="messageService.clear();"
      class="ui-button"></button>
    </div>
  </ng-template>
</p-toast>


<div class="container">
  <br>
    <h2>Advertised Rates Report</h2>
    <app-search-template searchLabel="Search" [showSearchButton]=true [reset]=true [showLocations]=true [showDevelopments]=true
      [showShortTermRentals]=true [showRateBuckets]=true  [showBedrooms]=true [showSeasons]=false [showStartDate]=true
    [showEndDate]=true (doSearchCB)="onSearchSubmit($event)"></app-search-template>
    <br><br>

    <p-table #dt [value]="advertisedRateRows" [columns]="scrollingColumns" [frozenColumns]="frozenColumns"
      [frozenWidth]="frozenWidth" [scrollable]="true" scrollHeight="100%" sortMode="multiple" [loading]="formLoading">

      <ng-template pTemplate="frozencolgroup" let-columns>
        <colgroup>
        <col style="width:100px">
        <col style="width:100px">
        <col style="width:100px">
        <col style="width:100px">
      </colgroup>
    </ng-template>

    <ng-template pTemplate="colgroup" let-columns>
      <colgroup>
      @for (col of columns; track col) {
        <col style="width:75px;">
      }
    </colgroup>
  </ng-template>

  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (col of frozenColumns; track col) {
        <th style="height:100px;min-width:107px;width:100%;padding: .2em .2em !important;"
          [pSortableColumn]="col.field" pFrozenColumn>
          <div class="d-flex flex-column">
            {{col.header}}
            <div>@if (col.field === 'rateBucketName') {
              <input (click)="clickOnFilter($event)" style="width:50px"
                pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')">
            }
          </div>
          <div>@if (col.field === 'bedrooms') {
            <input (click)="clickOnFilter($event)" style="width:50px" pInputText
              type="text" (input)="dt.filter($event.target.value, col.field, 'startsWith')">
          }</div>
          <div>@if (col.field === 'adrDevelopmentName') {
            <input (click)="clickOnFilter($event)" style="width:100px"
              pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')">
          }
        </div>
        <div>@if (col.field === 'propertyCode') {
          <input (click)="clickOnFilter($event)" style="width:100px"
            pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')">
        }
      </div></div>
    </th>
  }
  @for (col of columns; track col) {
    <th style="height:100px;min-width:75px;padding: .2em .2em !important;"
      [pSortableColumn]="col.field">
      {{col.header}}
      <div>@if (col.field === 'rateBucketName') {
        <input (click)="clickOnFilter($event)" style="width:50px"
          pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')">
      }
    </div>
    <div>@if (col.field === 'bedrooms') {
      <input (click)="clickOnFilter($event)" style="width:50px" pInputText
        type="text" (input)="dt.filter($event.target.value, col.field, 'startsWith')">
    }</div>
    <div>@if (col.field === 'adrDevelopmentName') {
      <input (click)="clickOnFilter($event)" style="width:100px"
        pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')">
    }
  </div>
  <div>@if (col.field === 'propertyCode') {
    <input (click)="clickOnFilter($event)" style="width:100px"
      pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')">
  }
</div>
</th>
}
</tr>
</ng-template>
<ng-template pTemplate="body" let-rowData let-columns="columns">
  <tr>
    @for (col of frozenColumns; track col) {
      <td style="height:50px;min-width: 107px; width:100%;padding: .2em .2em !important;"
        [style.border-right]="getSeasonColor(rowData[col.field],col.field)"
        [style.background-color]="getOccupiedBackgroundColor(rowData[col.field],col.field)">
        @if (col.field === 'rateBucketName') {
          <span>
            {{rowData[col.field]}}
          </span>
        }
        @if (col.field === 'bedrooms') {
          <span>
            {{rowData[col.field]}}
          </span>
        }
        @if (col.field === 'adrDevelopmentName') {
          <span>
            {{rowData[col.field]}}
          </span>
        }
        @if (col.field === 'propertyCode') {
          <span>
            {{rowData[col.field]}}
          </span>
        }
        @if (col.field!='rateBucketName'&&col.field!='bedrooms'&&col.field!='adrDevelopmentName'&&col.field!='adrDevelopmentName'&&rowData[col.field]) {
          <span
            >
            <span
              (click)="onOpenLosView(rowData[col.field].shortTermRentalId,rowData[col.field].analyzedDate, $event)"
            [style.color]="getPriceFontColor(rowData[col.field])">{{rowData[col.field].activeRate | currency : 'USD' : 'symbol' : '1.0-0'}}</span><br>
            <span style="color:grey"
            (click)="onOpenRateBucketDetailEdit(rowData[col.field].rateBucketDetailId, $event)">{{rowData[col.field].defaultRate | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
          </span>
        }
      </td>
    }
    @for (col of columns; track col) {
      <td style="height:50px;min-width: 75px;  padding: .2em .2em !important;"
        [style.border-right]="getSeasonColor(rowData[col.field],col.field)"
        [style.background-color]="getOccupiedBackgroundColor(rowData[col.field],col.field)">
        @if (col.field === 'rateBucketName') {
          <span>
            {{rowData[col.field]}}
          </span>
        }
        @if (col.field === 'bedrooms') {
          <span>
            {{rowData[col.field]}}
          </span>
        }
        @if (col.field === 'adrDevelopmentName') {
          <span>
            {{rowData[col.field]}}
          </span>
        }
        @if (col.field === 'propertyCode') {
          <span>
            {{rowData[col.field]}}
          </span>
        }
        @if (col.field!='rateBucketName'&&col.field!='bedrooms'&&col.field!='adrDevelopmentName'&&col.field!='adrDevelopmentName'&&rowData[col.field]) {
          <span
            >
            <span
              (click)="onOpenLosView(rowData[col.field].shortTermRentalId,rowData[col.field].analyzedDate, $event)"
            [style.color]="getPriceFontColor(rowData[col.field])">{{rowData[col.field].activeRate | currency : 'USD' : 'symbol' : '1.0-0'}}</span><br>
            <span style="color:grey"
            (click)="onOpenRateBucketDetailEdit(rowData[col.field].rateBucketDetailId, $event)">{{rowData[col.field].defaultRate | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
          </span>
        }
      </td>
    }
  </tr>
</ng-template>
</p-table>
</div>
